import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typo } from "../typography";
import { useTheme } from "styled-components";
import { StyledBadge, BadgeWrapper, StyledLabel, StyledValue, } from "./badge.styles";
import { getSizes, isBig } from "./badge.utils";
export function Badge({ label, color = "default", key, value, maxValue = 99, size = "big", }) {
    const theme = useTheme();
    let definedSize = value && size === "standard" ? "standard" : "big";
    if (!isBig(size, value)) {
        if (label) {
            definedSize = "tiny";
        }
        else {
            definedSize = "small";
        }
    }
    const labelContainer = (_jsx(StyledLabel, Object.assign({ color: color, value: value, theme: theme }, { children: _jsx(Typo, Object.assign({ variant: "label1" }, { children: label })) })));
    const valueContainer = (_jsx(StyledValue, Object.assign({ color: color, theme: theme }, { children: _jsx(Typo, Object.assign({ variant: "label1", fontWeight: theme.fontWeights.medium, size: {
                xsmall: [
                    getSizes[definedSize].fontSize,
                    getSizes[definedSize].lineHeight,
                ],
            } }, { children: value && value > maxValue ? `${maxValue}+` : value })) })));
    return (_jsxs(BadgeWrapper, Object.assign({ label: label, value: value }, { children: [_jsx(StyledBadge, Object.assign({ value: value, label: label, size: definedSize, theme: theme, color: color }, { children: isBig(definedSize, value) && valueContainer })), !!label && !value && labelContainer] }), key));
}
